import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { downloadRefuelingContractAttachment } from '../../api/refueling-contract.ts';

import type { DownloadRefuelingContractAttachmentRequest } from '../../api/requests/refueling-contract-request.ts';

export default function useDownloadRefuelingContractAttachment(): UseMutationResult<
  string,
  Error,
  DownloadRefuelingContractAttachmentRequest
> {
  return useMutation({
    mutationFn: async (request: DownloadRefuelingContractAttachmentRequest) => {
      const response = await downloadRefuelingContractAttachment(request);
      return response.data.downloadUrl;
    },
  });
}
